import { render, staticRenderFns } from "./notice-dialog.vue?vue&type=template&id=2e8af028&scoped=true"
import script from "./notice-dialog.vue?vue&type=script&lang=js"
export * from "./notice-dialog.vue?vue&type=script&lang=js"
import style0 from "./notice-dialog.vue?vue&type=style&index=0&id=2e8af028&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8af028",
  null
  
)

export default component.exports